import React from "react";
import { Button, Modal } from "react-bootstrap";
import FontAwesome from "react-fontawesome";

import AppointmentCalendar from "../../shared/AppointmentCalendar";
import LoadingSpinner from "../../shared/LoadingSpinner";
import {
  editAppointmentModal,
  editAppointmentModalConfirm,
  editAppointmentModalUpdateConfirm,
} from "../../../redux/modals";

const AppointmentCalendarModal = ({
  form,
  loading,
  onConfirm,
  onEditConfirm,
  onIndividualConfirm,
  onSplitConfirm,
  onHide,
  show,
  ...props
}) => {
  return (
    <Modal onHide={onHide} show={show}>
      <Modal.Header>
        <Modal.Title>
          <FontAwesome name="pencil" />{" "}
          {form.id ? "Edit Calendar Event" : "Add Calendar Event"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && <LoadingSpinner />}
        <AppointmentCalendar {...props} event={form} />
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide}>Close</Button>
        {form.id ? (
          <Button bsStyle="primary" onClick={onSplitConfirm}>
            Split into Individual Events
          </Button>
        ) : (
          <Button bsStyle="primary" onClick={onIndividualConfirm}>
            Create Individual Events
          </Button>
        )}

        <Button bsStyle="primary" onClick={form.id ? onEditConfirm : onConfirm}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AppointmentCalendarModal;
